module.exports = __webpack_public_path__ + "img/ea_bg.2396476e.png";